import React from 'react';
import { Image } from '../styles';
import styled from 'styled-components';
//Import Icons
import clock from '../img/clock.svg';
import money from '../img/money.svg';
import teamwork from '../img/teamwork.svg';
import homeImg2 from '../img/home2.jpg';
//Scroll animation
import { reveal } from '../animation';
import { useScroll } from './useScroll';

const ServicesSection = () => {
  const [element, controls] = useScroll();
  return (
    <Services
      transition={{ duration: 0.75 }}
      ref={element}
      variants={reveal}
      animate={controls}
      initial="hidden"
    >
      <Description>
        <h2>
          High <span>quality</span> services.
        </h2>
        <Cards>
          <Card>
            <div className="icon">
              <img src={clock} alt="" />
              <h3>Efficient</h3>
            </div>
            <p>Lorem ipsum dolor sit amet.</p>
          </Card>
          <Card>
            <div className="icon">
              <img src={teamwork} alt="" />
              <h3>Teamwork</h3>
            </div>
            <p>Lorem ipsum dolor sit amet.</p>
          </Card>
          <Card>
            <div className="icon">
              <img src={money} alt="" />
              <h3>Affordable</h3>
            </div>
            <p>Lorem ipsum dolor sit amet.</p>
          </Card>
        </Cards>
      </Description>
      <Image>
        <img src={homeImg2} alt="camera" />
      </Image>
    </Services>
  );
};

const Services = styled.div`
  min-height: 90vh;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5rem 10rem;
  h2 {
    padding-bottom: 5rem;
  }
  @media (max-width: 1500px) {
    padding: 5rem ;
  }
  @media (max-width: 1200px) {
    display: block;
    padding: 2rem 2rem;
    text-align:center;
  }
  @media (max-width: 800px) {
    padding: 5rem 1rem;
  }
  @media (max-width: 400px) {
    padding: 3rem 1rem 4rem 1rem;
  }
  
`;
const Description = styled.div`
  flex: 1;
  z-index: 3;
  padding-right: 5rem;
  h2 {
    font-weight: lighter;
    z-index: 3;
  }
  @media (max-width: 1200px) {
    padding: 0 0.5rem;
    margin-bottom: 6rem;
  }

  @media (max-width: 450px) {
    margin-bottom: 4rem;
    h2{
     font-size: 2.8rem;
   }
  }
`
const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;

  width:100%;
  @media (max-width: 1200px) {
   justify-content: center;
   align-items:center;
  }
`;
const Card = styled.div`
 display:flex;
 flex-direction:column;
 align-items:flex-start;
justify-content:space-between;

  .icon {
    display: flex;
    align-items: center;
    h3 {
      margin-left: 1rem;
      background: white;
      color: black;
      padding: 1rem;
    }
  }
  p{
    width: 70%;
    padding:1.5rem 0;
  }
@media (max-width: 1200px){
  align-items:center;
}
 
`;

export default ServicesSection;
